import { useState, useEffect } from "react";
import { fetchContent } from "../../services/parameter.service";

const useContentAsociacionUsuariosMiembros = () => {
  const [asociacionUsuariosMiembros, setAsociacionUsuariosMiembros] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const getAsociacionUsuariosMiembros = async () => {
    setIsLoading(true);

    try {
      const responseContent = await fetchContent("asociacionusuariosmiembros");
      setAsociacionUsuariosMiembros(responseContent.data.list);

      setIsLoading(false);
    } catch (error) {
      console.error(" ERROR EN useContentAsociacionUsuariosMiembros --> ", error);
    }
  };

  useEffect(() => {
    getAsociacionUsuariosMiembros();
  }, []);

  return {
    asociacionUsuariosMiembros 
  };
};

export default useContentAsociacionUsuariosMiembros;
